<template>

<section class="attention_section gray_section" v-if="newsItems.length > 0">
    <div class="wrap" style="background:none">
        {{checker}}
        <h2 class="section_title">주목할만한 소식<router-link to="/newsList" style="font-weight:500; font-size:12px">전체보기<i class="far fa-chevron-right"></i></router-link></h2>
        <ul class="attention_ul">
            
            <li v-for="news in newsItems" :key="news.id">
                
                <a @click="$router.push(`/newsInfo/${news.id}`)">
                    <figure>
                        <img :src="news.boardUrl">
                    </figure>
                    <figcaption>
                        <p>
                            {{news.title}}
                        </p>
                        <span>
                            <img :src="news.brandUrl" alt="" height="20px">
                            {{news.dealerName}}
                        </span>
                    </figcaption>
                </a>
            </li>
        </ul>
    </div>

</section>

</template>

<script>
import { mapState } from 'vuex';
import { DateFormatMixin } from '../../mixins/DateFormatMixin';

export default {
    name:'MainNews',
    mixins:[DateFormatMixin],
    props: {
        onload: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            filters: {...this.$store.state.board.filters},
            checker:'',

            newsItemsOnload: [],
            newsItems: [],
        }
    },
    computed: {
        ...mapState({
            // newsItems: state => state.board.items,
            NEWS_DTYPE_MAIN: state => state.codeDictionary.items.BOARD_DTYPE.NEWS.id,
            // onload: state => state.common.onload,
        })
    },
    watch: {
        onload(val) {
            if(val) {
                this.newsItems = this.newsItemsOnload;
            }
        }
    },

    created () {
        
    },
    methods:{
        async getItems(){
            let today = this.dayjsFormat(this.getToday() , 'YYYY-MM-DD');
            await this.$store.dispatch('GET_BOARD_LIST', {
                sort : 'startDt,DESC',
                type:this.NEWS_DTYPE_MAIN,
                size : 1,
                showDt: today,
                showYn: 'Y'
            })            
            .then((data)=>{
                this.newsItemsOnload = data.content;
            }).catch((e)=> {
                throw e;
            }); 
        }
    },
}
</script>

<style scoped>

</style>